export default __webpack_public_path__ + "static/media/provesional_restoration_lower_14_2@2x.8cf50739.png";